/** Web: считать access истёкшим за SAFETY_MARGIN_SECONDS до реального expires_at */
export const ACCESS_TOKEN_SAFETY_MARGIN_SECONDS = 120;

/** Не чаще одного раза за интервал при параллельных 401 */
export const AUTH_REFRESH_COOLDOWN_MS = 5000;

/** Монолит отвечает 420, если аккаунт временно ограничен (ban) */
export const HTTP_STATUS_BANNED = 420;

/** Явный invalid/expired refresh — единственный статус, после которого можно разлогинить */
export const HTTP_STATUS_UNAUTHORIZED = 401;

export const ACCESS_TOKEN_COOKIE = 'access_token';
export const REFRESH_TOKEN_COOKIE = 'refresh_token';
export const WELLITORY_SESSION_COOKIE = 'welltorysessionid';
